(function(){
  'use strict';
  function guided(){return new URLSearchParams(location.search||'').get('edg_guided')==='1';}
  function fixRoute(){
    if(!guided()) return;
    var root=document.querySelector('[data-edg-guide]');
    var link=root&&root.querySelector('[data-non-fi-route] .edg-guide__route-link');
    if(link) link.href='/products/martingale-collar?edg_guided=1';
  }
  function fixGuidance(){
    var guide=document.querySelector('[data-edg-fi-guidance]');
    if(!guide) return;
    Array.prototype.slice.call(guide.querySelectorAll('p')).forEach(function(p){
      if((p.textContent||'').indexOf('Tactical Buckle')>=0){
        p.textContent='The standard Fi Martingale build slips over the head, so both the neck and widest-head measurements matter. If you add the Tactical Buckle, the collar opens fully and EDG sizes the build from the neck measurement instead.';
      }
    });
  }
  function fix(){fixRoute();fixGuidance();}
  function boot(){fix();setTimeout(fix,120);setTimeout(fix,500);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();
